import MutateObserver from "./MutateObserver";
import useMutateObserver from "./useMutateObserver";
export { useMutateObserver };
export default MutateObserver;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rc-component/mutate-observer/es/index.js
// module id = 4166
// module chunks = 0